/** Domain service module: auth.js */
import client from '../http/client'
import { request } from '../http/request'
import { API_BASE_URL, BASE_URL } from './config'

class AuthDataService {
  isLoggedIn() {
    return localStorage.getItem('loggedIn') ? true : false
  }
  user() {
    let _user = localStorage.getItem('user')
    try {
      _user = _user ? JSON.parse(_user) : {}
    } catch (error) {
      _user = {}
    }
    return _user
  }
  login(email, password) {
    return new Promise(async (resolve, reject) => {
      try {
        // get token
        let _resultToken = await client.get(`${BASE_URL}/sanctum/csrf-cookie`)
          .catch((error) => {
            throw error;
          });
        let _result = await request(`${API_BASE_URL}/login`, 'post', { email, password })
          .catch((error) => {
            throw error;
          });
        localStorage.loggedIn = 1
        // get me
        let _resultMe = await request(`${API_BASE_URL}/me`, 'get')
          .catch((error) => {
            throw error;
          });
        let _user = _resultMe?.data?.data
        localStorage.user = JSON.stringify(_user)
        resolve(_user || null)
      } catch (error) {
        reject(error)
      }
    });
  }
  me() {
    return new Promise(async (resolve, reject) => {
      try {
        // get me
        if (this.isLoggedIn()) {
          let _resultMe = await request(`${API_BASE_URL}/me`, 'get')
          localStorage.user = JSON.stringify(_resultMe?.data?.data)
          resolve(_resultMe?.data?.data || null)
        } else {
          resolve({})
        }
      } catch (error) {
        reject(error)
      }
    });
  }
  updateMe(data) {
    return new Promise(async (resolve, reject) => {
      try {
        // get me
        let _resultMe = await request(`${API_BASE_URL}/user/update/${data.id}`, 'post', { ...data })
        localStorage.user = JSON.stringify(_resultMe?.data?.data)
        resolve(_resultMe?.data?.data || null)
      } catch (error) {
        reject(error)
      }
    });
  }
  logout() {
    return new Promise(async (resolve, reject) => {
      try {
        let _result = await request(`${API_BASE_URL}/logout`, 'post')
        localStorage.removeItem('loggedIn');
        localStorage.removeItem('user');
        resolve(_result?.data?.data || null)
      } catch (error) {
        reject(error)
      }
    });
  }
  logoutAndRedirect() {
    this.logout()
      .then(() => {
        window.location.replace('/')
      }).catch((err) => {
        console.error(err);
      });
  }
  resetPasswordRequest(email) {
    return new Promise(async (resolve, reject) => {
      try {
        let _result = await request(`${API_BASE_URL}/resetPassword`, 'post', { email, reset: true })
        resolve(_result?.data?.data || null)
      } catch (error) {
        reject(error)
      }
    });
  }
  resetPassword(email, password, token) {
    return new Promise(async (resolve, reject) => {
      try {
        let _result = await request(`${API_BASE_URL}/resetPassword`, 'post', { email, password, token })
        resolve(_result?.data?.data || null)
      } catch (error) {
        reject(error)
      }
    });
  }
}

export const auth = new AuthDataService()
export default auth
